import React from "react";
import { Modal } from "@mui/material";
import { Content } from "./styles";
import { Typography } from "@mui/material";
import TypeWriter from "typewriter-effect";
import { CircularProgress } from "@mui/material";
export const ModalLoader = ({ open = false, text }) => {
  return (
    <Modal open={Boolean(open)}>
      <Content>
        <CircularProgress style={{ verticalAlign: "sub", color: "white" }} />
        <Typography variant="h5">
          <TypeWriter
            options={{
              strings: [text],
              autoStart: true,
              loop: true,
            }}
          />
        </Typography>
      </Content>
    </Modal>
  );
};
